import { render, staticRenderFns } from "./editStep4.vue?vue&type=template&id=6b80501e&scoped=true&"
import script from "./editStep4.vue?vue&type=script&lang=js&"
export * from "./editStep4.vue?vue&type=script&lang=js&"
import style0 from "./editStep4.vue?vue&type=style&index=0&id=6b80501e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b80501e",
  null
  
)

export default component.exports